import {useSelector} from 'react-redux';

export default () => useSelector(({activityLog}) => [activityLog.data, activityLog.lastRefreshed]);
